export default "__VITE_ASSET__D5SiZlZ1__"